import { Array } from './context'

export default function isArray(data) {
  return Array.isArray(data)
}
